import { useEffect, useState } from 'react';
import { Images } from 'assets/images';
import { ROUTES } from 'utils/routeNames';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { initialSettingsData } from 'containers/settings/data';
import { settingsActions } from 'store';
import { useCustomNavigation } from 'hooks';
import {
  PASSWORD_COMPONENT_ID,
  DELETE_ACCOUNT_ID,
  ACTIVE_CLASS,
  PASSWORD_TEXT,
  DELETE_ACCOUNT_TEXT,
} from 'utils/constant';
import {
  CategoriesSection,
  CategoryTextField,
  ImageContainer,
  SettingsCategories,
  UserEmail,
  UserImage,
  UserImageWithUpdateAndDelete,
  UserName,
} from './styled';
import {
  SettingsWrapper,
  MainSettingsContainer,
  BackToPrevPageBlock,
  IconToPrevPage,
  SettingsRightSection,
  CategoryName,
} from 'containers/settings/styled';

export const SettingsPageLayout = ({ children }) => {
  const { user } = useSelector(({ auth }) => auth);
  const [currentUser, setCurrentUser] = useState(initialSettingsData);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { back } = useCustomNavigation();

  useEffect(() => {
    if (user) {
      setCurrentUser(user.data);
      dispatch(settingsActions.getCountries());
      dispatch(settingsActions.getCities(user?.data?.country?.id));
    }
  }, [dispatch, user]);

  return (
    <SettingsWrapper>
      <MainSettingsContainer>
        <BackToPrevPageBlock>
          <IconToPrevPage src={Images.backVector} onClick={back} />
        </BackToPrevPageBlock>

        <SettingsCategories>
          <ImageContainer>
            <UserImageWithUpdateAndDelete>
              <UserImage
                src={
                  currentUser.profile_photo_path
                    ? currentUser.profile_photo_path
                    : Images.defaultAvatar
                }
              />
            </UserImageWithUpdateAndDelete>
          </ImageContainer>

          <UserName>{currentUser.name}</UserName>

          <UserEmail>{currentUser.email}</UserEmail>

          <CategoriesSection>
            <CategoryTextField onClick={() => navigate(ROUTES.SETTINGS)}>
              Profile Settings
            </CategoryTextField>

            <CategoryTextField
              onClick={() => navigate(ROUTES.CHANGE_PASSWORD)}
              className={
                children?.props?.id === PASSWORD_COMPONENT_ID ? ACTIVE_CLASS : null
              }
            >
              Password
            </CategoryTextField>

            <CategoryTextField
              className={
                children?.props?.id === DELETE_ACCOUNT_ID ? ACTIVE_CLASS : null
              }
              onClick={() => navigate(ROUTES.DELETE_ACCOUNT)}
            >
              Delete Account
            </CategoryTextField>
          </CategoriesSection>
        </SettingsCategories>
        <SettingsRightSection>
          <CategoryName>
            {children?.props?.id === PASSWORD_COMPONENT_ID
              ? PASSWORD_TEXT
              : DELETE_ACCOUNT_TEXT}
          </CategoryName>
          <div>{children}</div>
        </SettingsRightSection>
      </MainSettingsContainer>
    </SettingsWrapper>
  );
};
